module.exports = __webpack_public_path__ + "static/media/pointC.08435a9f.png";